import getMemberRegistrationStatus from './GetMemberRegistrationStatusData';

const MemberRegistrationStatusData = { getMemberRegistrationStatus };

export default MemberRegistrationStatusData;